export const AppVariant = Object.freeze({
    ME_BUSINESS: "me_business",
    CHECKED_IN: "checked_in"
});

const meBusiness = Object.freeze({
    variant: AppVariant.ME_BUSINESS,
    brandName: "Me Business",
    displayName: "Me Business App",
    brandBackgroundColor: "#112870",
    websiteUrl: "https://www.mebusiness.com.au",
    downloadUrl: "https://www.mebusiness.com.au/download",
    appStoreUrl: "https://apps.apple.com/au/app/me-business-engage-connect/id6504783839",
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.onpoint_holdings.mebusinessapp",
    termsUrl: "https://www.mebusiness.com.au/terms-conditions",
    privacyUrl: "https://www.mebusiness.com.au/privacy-policy",
    supportEmail: "support@memotivationapp.com"
});

const checkedIn = Object.freeze({
    variant: AppVariant.CHECKED_IN,
    brandName: "Checked In",
    displayName: "Checked In",
    brandBackgroundColor: "#2A1E14",
    websiteUrl: "https://www.checkedin-app.com",
    downloadUrl: "https://getthecheckedinapp.com",
    appStoreUrl: "https://apps.apple.com/us/app/checked-in-well-travelled/id6818358905",
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.onpoint_holdings.checkedin",
    termsUrl: "https://www.checkedin-app.com/terms-conditions",
    privacyUrl: "https://www.checkedin-app.com/privacy-policy-1",
    supportEmail: "support@checkedin-app.com"
});

export const getAppDetails = variant => variant === AppVariant.CHECKED_IN ? checkedIn : meBusiness;
